<template>
  <div class="ui-chart">
    <div :id="id" class="ui-chart__canvas" :ref="id"></div>
  </div>
</template>

<script>
import echarts from 'echarts'

export default {
  name: 'UiChart',
  props: {
    id: {
      type: String,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      chart: null,
    }
  },
  methods: {
    refreshOptions() {
      this.chart.setOption(this.options, {
        notMerge: true,
      })
    },
  },
  watch: {
    'options.series': {
      deep: true,
      handler() {
        this.refreshOptions()
      },
    },
  },
  mounted() {
    this.chart = echarts.init(document.getElementById(this.id))
    this.refreshOptions()
    window.addEventListener('resize', () => {
      this.chart.resize({
        width: this.$refs[this.id].clientWidth,
      })
    })
  },
}
</script>

<style lang="scss">
.ui-chart {
  &__canvas {
    height: 100%;
    max-height: 100%;
  }
}
</style>
